__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/4ad117b8d573bcccf6a637562368b9c2b5c4dd030c35bc75ad989bd7/";